import { WebViewMessageObject } from 'types/native';

export const getFeatures = () => window?.nativeInfo?.features;

export const reactNativePostMessage = (object: Partial<WebViewMessageObject>) =>
  window?.ReactNativeWebView?.postMessage(JSON.stringify(object));
